module.exports = __webpack_public_path__ + "media/images/common/product_content_top_bg-af58f3e77a3a0314a5e15dba80482838.png";